import { ScheduleMembership } from '#pages/WeeklyCalenderScheduleRegistration/LectureScheduleContents/useScheduleMembership';
import { useNavigate } from 'react-router';
import { AddButton } from './AddButton';
import { ItemList } from './ItemList';

export const AddMembership = () => {
  const navigate = useNavigate();

  const onClick = (params: ScheduleMembership) => {
    const personId = sessionStorage.getItem('personId');

    if (!personId || !params) {
      return;
    }

    navigate(
      `/dashboard/customer/membership/${personId}/${params.confirmationFormId}`
    );
  };

  return (
    <div className="w-full px-20 pb-60">
      <ItemList onClick={onClick} />
      <div className="w-full h-24"></div>
      <AddButton />
    </div>
  );
};
